import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { ElementType } from 'react';

import { DialogCloseButton } from '../DialogCloseButton/DialogCloseButton';
import { TypographyIcon } from '../TypographyIcon/TypographyIcon';

type Props = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  icon?: ElementType;
  onClose?: () => void;
};

export const DrawerHeader = ({ title, subtitle, icon, onClose }: Props) => {
  return (
    <Box
      sx={{
        mb: 2,
        position: 'relative',
      }}
    >
      {onClose ? <DialogCloseButton onClick={onClose} sx={{ top: 0 }} /> : null}
      {icon ? (
        <TypographyIcon variant="h5" size="large" icon={icon}>
          {title}
        </TypographyIcon>
      ) : (
        <Typography variant="h5">{title}</Typography>
      )}
      {subtitle ? <Typography>{subtitle}</Typography> : null}
    </Box>
  );
};
